import React, { useState, useCallback, useEffect } from 'react';

import { Select, DefaultSheet, Button, FormGroup, Label, Input, SheetBody, SheetFooter, Row, Col } from 'twyne-new.ui';

import { ConfigureButton, useReportConfigure } from '@/components/reports/header';

export default function ConfigureFilter({ onChange, onChangeSearch, filters: { term, publisherId }, loadPublishers }) {
  const { open: isOpen, setOpen: setIsOpen } = useReportConfigure()
  const [search, setSearch] = useState(term || '')
  const [publisher, setPublisher] = useState(publisherId)
  const [publishersOptions, setPublishersOptions] = useState([])

  useEffect(() => {
    loadPublishers().then(({ data }) => {
      data = data.map(({ id, name }) => ({ value: id, label: `[#${id}] ${name}` }))
      setPublishersOptions(data)
    })
  }, [])

  const handleClear = () => {
    setSearch('')
    setPublisher(null)
  }

  const handleSave = useCallback(() => {
    onChangeSearch(search)
    onChange('publisherId', publisher)
  }, [search, publisher, onChangeSearch, onChange])

  const handleChangePublisher = opt => {
    setPublisher(opt && opt.value)
  }

  return <>
    <DefaultSheet
      title='Configure Filter'
      trigger={<ConfigureButton />}
      wrapperProps={{ open: isOpen, onOpenChange: setIsOpen }}
    >
      <SheetBody>
        <Row>
          <Col>
            <FormGroup>
              <Label>Search</Label>
              <Input placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>Publisher</Label>
              <Select
                options={publishersOptions}
                name="siteId"
                placeholder="Select the publisher"
                value={publisher}
                onChange={handleChangePublisher}
              />
            </FormGroup>
          </Col>
        </Row>
      </SheetBody>
      <SheetFooter>
        <Button onClick={handleClear} variant='ghost' >Clear</Button>
        <Button onClick={handleSave} color="accent">Apply</Button>
      </SheetFooter>
    </DefaultSheet>
  </>
}
